import { CarsState } from '../../types';

import { carsActions } from '../reducer';

export const updateCarEBoxLocationsFilter = (
  value: CarsState['eBoxLocations']['filter']
) => carsActions.updateEBoxLocationsFilter(value);